<template>
  <div>
    <div class="graph-title">
      <div class="float-left mt-2 left-heading">
        <h2>Completions by Month</h2>
      </div>
      <div class="float-right right-button">
        <el-select v-model="selectedDateRange" class="select-primary max-width" :class="brand.primary ? 'select-brand' : 'select-primary-orange'"  name="Date Range" placeholder="Filter by Date Range">
          <el-option v-for="(dateRange, index) in dateRanges" :key="index" :label="dateRange.label" :value="dateRange.value" class="select-primary"/>
        </el-select>
      </div>
      <div class="clearfix"></div>
    </div>
    <div id="chart">
      <apexchart type="area" height="350" :options="chartOptions" :series="series"></apexchart>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { Select, Option } from 'element-ui';
import { brandContext } from "@/brand/brandContext";

export default {
  name: "completions-graph",
  props: {
    company_id: {
      type: String,
      required: true
    }
  },
  components: {
    apexchart: VueApexCharts,
    'el-select': Select,
    'el-option': Option,
  },
  data() {
    return {
      series: [{
        name: "Total Completions",
        data: []
      }],
      chartOptions: {
        chart: {
          type: 'area',
          height: 350,
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          }
        },
        colors: ['#FF4500'], // Orange color
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 3
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.3,
            opacityTo: 0.1,
            stops: [0, 100]
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            format: 'MMM yyyy',
            datetimeUTC: false,
            style: {
              fontSize: '12px'
            }
          },
          title: {
            text: 'Month',
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          },
          tooltip: {
            format: 'MMM yyyy'
          }
        },
        yaxis: {
          title: {
            text: 'Courses',
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          },
          labels: {
            offsetX: 5,
            style: {
              fontSize: '12px'
            },
            formatter: function (val) {
              return Math.round(val); // Ensures only whole numbers
            }
          },
          min: 0,
          forceNiceScale: true, // Ensures even distribution of labels
          tickAmount: 5, // Adjust this to control label frequency
        },

        tooltip: {
          theme: 'light',
          x: {
            format: 'MMM yyyy'
          }
        },
        legend: {
          show: false // Hide legend for single series
        },
        responsive: [{
          breakpoint: 600,
          options: {
            chart: {
              height: 300
            },
            xaxis: {
              labels: {
                show: false
              }
            }
          }
        }]
      },
      dateRanges: [
        { label: 'Last 30 Days', value: 1 },
        { label: 'Last 60 Days', value: 2 },
        { label: 'Last 90 Days', value: 3 },
        { label: '6 Months', value: 6 },
        { label: '12 Months', value: 12 },
      ],
      selectedDateRange: 6,
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    brand() {
      return brandContext.state;
    },
  },
  methods: {
    updateChartData(data) {
      const seriesData = data.map(item => {
        const parsedDate = new Date(item.month);
        if (isNaN(parsedDate)) {
          console.warn(`Invalid date format for month: ${item.month}`);
          return { x: null, y: Math.round(item.count) };
        }
        return {
          x: parsedDate.getTime(),
          y: Math.round(item.count) // Ensure whole numbers only
        };
      }).filter(item => item.x !== null);

      this.series = [{
        name: "Total Completions",
        data: seriesData
      }];
    },
    fetchData() {
      this.$http
        .post("analytics/get_course_completions_byMonth", {
          company_id: this.company_id,
          dateRange: this.selectedDateRange,
        })
        .then(response => {
          this.updateChartData(response.data);
        })
        .catch(error => {
          console.error("API failed for loading completions data:", error);
        });
    }
  },
  watch: {
    company_id() {
      this.fetchData();
    },
    selectedDateRange() {
      this.fetchData();
    }
  }
};
</script>
<style>
  .graph-title .left-heading{
    @media only screen and (max-width: 440px) {
       text-align: center;
       margin-bottom: 15px;
    }
  }
  .graph-title .right-button {
    @media only screen and (max-width: 440px) {
       text-align: center;
       margin-bottom: 10px;
       .select-primary-orange.max-width {
        max-width: 132px;
      }
    }
  }



/* brand-aware */
.select-brand .el-input__inner {
  background: var(--brand-primary);
  border-color: var(--brand-primary);
  color: #fff;
  border-radius: 30px;
}

</style>
